import * as yup from 'yup';
import { validEmail } from 'utils';

const nameAllowed = /^(\p{L}[\p{L}\p{M}'’-]*)( \p{L}[\p{L}\p{M}'-]*)?$/u;

const nameNoEdge = /^(?!['-])(.*?)(?<!['-])$/u;

const nameNoConsecutive = /^(?!.*(['-]){2,}).*$/u;

const nameValidation = yup
  .string()
  .trim()
  .required('profile.accessModal.error.required')
  .min(2, 'profile.accessModal.error.min')
  .max(30, 'profile.accessModal.error.max')
  .matches(nameAllowed, 'profile.accessModal.error.invalidCharType')
  .matches(nameNoEdge, 'profile.accessModal.error.trailingSpecialChars')
  .matches(nameNoConsecutive, 'profile.accessModal.error.specialCharsInRow');

export const schema = yup.object().shape({
  name: nameValidation,
  lastname: nameValidation,
  email: yup
    .string()
    .trim()
    .required('profile.accessModal.error.required')
    .matches(validEmail, 'profile.accessModal.error.email'),
});
